import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Collapse from 'components/Collapse';
import TasksExecsService from 'mt-react-common/modules/tasks/services/TasksExecsService';
import MediumPreLoader from 'components/Common/PreLoaders/MediumPreLoader';
import TaskExecLogItem from '../TaskExecLogItem';
import './index.css';

const MoreUserReports = props => {
  const { execLogItem, userRepeatsAmount } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [isLodaing, setIsLoading] = useState(false);
  const [moreReports, setMoreReports] = useState();
  const store = useSelector(state => state);

  const fetch = () => {
    setIsLoading(true);
    TasksExecsService.getMoreUserReports(store, execLogItem.taskExecId).then(
      responseModel => {
        console.log(responseModel);
        if (responseModel && responseModel.response.status === 200) {
          setMoreReports(responseModel.destructData.items);
        }
        setIsLoading(false);
      }
    );
  };

  if (execLogItem.eventType === 2 && userRepeatsAmount > 0) {
    return (
      <div className={'m-t-10'}>
        <div className="more-user-reports_link-block">
          <a
            href=""
            onClick={e => {
              e.preventDefault();
              if (!moreReports) {
                fetch();
              }
              setIsOpen(!isOpen);
            }}
          >
            {isOpen ? (
              <React.Fragment>Скрыть прошлые отчеты исполнителя</React.Fragment>
            ) : (
              <React.Fragment>
                Показать прошлые отчеты исполнителя
              </React.Fragment>
            )}
          </a>
        </div>
        <Collapse isOpen={isOpen}>
          {moreReports ? (
            <div className={'m-t-10'}>
              {moreReports.map(item => (
                <TaskExecLogItem execLogItem={item} />
              ))}
            </div>
          ) : null}
          {isLodaing ? <MediumPreLoader /> : null}
        </Collapse>
      </div>
    );
  }

  return null;
};

MoreUserReports.propTypes = {
  execLogItem: PropTypes.shape({
    eventType: PropTypes.number.isRequired,
    taskExecId: PropTypes.number.isRequired
  }).isRequired,
  userRepeatsAmount: PropTypes.number
};

MoreUserReports.defaultProps = {
  userRepeatsAmount: null
};

export default MoreUserReports;



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/_items/TaskExecLogItem/MoreUserReports/index.jsx